/**
 * Welche Zeichen die PDF-Standardschriften (Helvetica, Times, Courier) in
 * pdf-lib darstellen können: WinAnsiEncoding (Windows-1252).
 *
 * Der Server (`apps/api/src/pdf-bearbeitung/text-schreiben.ts`) hat dieselbe
 * Tabelle und ersetzt alles andere hart durch „?“. Hier im Browser markiert der
 * Kasten solche Zeichen schon beim Tippen, damit niemand überrascht wird.
 */

/** Die Plätze 0x80–0x9F von Windows-1252, soweit belegt. */
const CP1252_ZUSATZ = "€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ";

const ZUSATZ = new Set(Array.from(CP1252_ZUSATZ));

/** Ein Zeichen (auch ein Emoji aus zwei UTF-16-Einheiten). */
export function istDarstellbar(zeichen: string): boolean {
    const cp = zeichen.codePointAt(0);
    if (cp === undefined) return false;
    if (cp >= 0x20 && cp <= 0x7e) return true;
    if (cp >= 0xa0 && cp <= 0xff) return true;
    return ZUSATZ.has(zeichen);
}

/** Alle nicht darstellbaren Zeichen des Texts, jedes einmal, in der Reihenfolge des Auftretens. */
export function nichtDarstellbare(text: string): string[] {
    const gefunden: string[] = [];
    for (const z of Array.from(text)) {
        if (!istDarstellbar(z) && !gefunden.includes(z)) gefunden.push(z);
    }
    return gefunden;
}
